/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, pool: NonNullable<unknown> }} Dashboard_Billing_Covered_ValueInputs */



/**
* | output |
* | --- |
* | "{used} of {pool} pool" |
*
* @param {Dashboard_Billing_Covered_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_covered_value = /** @type {((inputs: Dashboard_Billing_Covered_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Covered_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.used} von ${i?.pool} Pool`)
	return /** @type {LocalizedString} */ (`${i?.used} of ${i?.pool} pool`)
});